exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/core-js/modules/_object-gops.js
// module id = 179
// module chunks = 1